<div class="row">
    <div class="col-xl-4 col-lg-6">
        <div class="card mb-5">
            <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-1.jpg"/>
            <div class="card-body">
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <a class="btn btn-primary" [routerLink]="">Go somewhere</a>
            </div>
        </div>
    </div>
    <div class="col-xl-4 col-lg-6">
        <div class="card mb-5">
            <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-2.jpg"/>
            <div class="card-body">
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <a class="btn btn-primary" [routerLink]="">Go somewhere</a>
            </div>
        </div>
    </div>
    <div class="col-xl-4 d-none d-xl-block">
        <div class="card mb-5">
            <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-3.jpg"/>
            <div class="card-body">
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <a class="btn btn-primary" [routerLink]="">Go somewhere</a>
            </div>
        </div>
    </div>
</div>
